module.exports = __webpack_public_path__ + "static/img/SelectTopic04.f563071.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/SelectTopic04.png
// module id = 4htX
// module chunks = 24